import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'
import * as filters from '../../filters/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-completionnumberlabel-dropdown',
  templateUrl: './CompletionNumberLabelDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => CompletionNumberLabelDropdownComponent)}]
})
export class CompletionNumberLabelDropdownComponent extends BaseDropdownComponent {

    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        var filter: filters.CompletionNumberLabelFilter = {IncludeInactive: false};
        this.domainDataService.getCompletionNumberLabels(filter).subscribe(x=> this.onGetRecordsDone(x));
    }
    
    onGetRecordsDone(items: ent.CompletionNumberLabel[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        if (this.selectedID){
            this.value = this.selectedID;
        }
        
    }

}